
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-grid-demo-xflow-components-grid-dot","docs-xflow-components-grid-demo-xflow-components-grid-fixed-dot","docs-xflow-components-grid-demo-xflow-components-grid-mesh","docs-xflow-components-grid-demo-xflow-components-grid-double-mesh"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.zh.md?type=demo')
};